















import Component, { mixins } from 'vue-class-component';
import { VModel } from 'vue-property-decorator';
import Form from '@/general/abstract/form/mixin/Form';
import { IdResponse } from '@/common/model/IdResponse';
import SensorRouter from '@/context/sensor/router/SensorRouter';
import { SensorFormModel } from '@/context/sensor/model/SensorFormModel';
import SensorForm from '@/context/sensor/component/form/SensorForm.vue';
import FormBase from '@/general/abstract/form/FormBase.vue';
import { sensorApi } from '@/context/sensor/api/SensorApi';

@Component({
  components: { FormBase, SensorForm }
})
export default class SensorCreateContainer extends mixins<
  Form<SensorFormModel, SensorFormModel, IdResponse>
>(Form) {
  @VModel({ default: new SensorFormModel() }) model!: SensorFormModel;

  buildCmd(): SensorFormModel {
    return this.model;
  }

  async submitApi(cmd: SensorFormModel): Promise<IdResponse> {
    // cast string to number
    cmd.registerNumber = Number(cmd.registerNumber);
    const result: IdResponse = await sensorApi.create<SensorFormModel, IdResponse>(cmd);
    return result;
  }

  showRoute(id: number): Record<string, unknown> {
    return new SensorRouter().show(id);
  }
}
